import { getSessionStorage } from '@utils/windowUtil';
import { filterHtmlModulesFromNav } from '@utils/htmlModuleConfig';
export const DEFAULT = 'default';
export const CUSTOMIZED = 'regular';

const getIconId = (icon) =>
  icon ? icon.split('-').slice(1, -1).join('-') : '';

const convertModtoNavProps = (
  { module, icon, iframe, link, type, ...restProps },
  to,
) => {
  if (!iframe && (type === 'regular' || type === 'powerbiModule')) {
    return {
      iframe,
      displayName: module,
      iconId: icon,
      showWhenHasId: true,
      isExternal: true,
      link,
      type,
      ...restProps,
      to,
    };
  }
  return {
    iframe,
    displayName: module,
    iconId: icon,
    showWhenHasId: true,
    isExternal: false,
    link,
    type,
    ...restProps,
    to,
  };
};

export const convertDefaultToNavProps = ({
  showWhenHasId,
  path,
  label,
  icon,
  ...restPtops
}) => ({
  showWhenHasId,
  to: path,
  displayName: label,
  iconId: getIconId(icon),
  isExternal: false,
  label,
  path,
  ...restPtops,
});

export const mergeTwoRoutes = (routes, cModules = []) => {
  if (cModules.length === 0) {
    return routes.map(convertDefaultToNavProps);
  }
  const defaultRoutesToShow = routes.filter((r) => !r.hideOnNav);
  const filteredModules = filterHtmlModulesFromNav(cModules);
  return filteredModules.map((m) => {
    if (
      m.type === 'regular' ||
      m.type === 'powerbiModule' ||
      m.type === 'imageModule' ||
      m.type === 'widget' ||
      m.type === 'multiSection' ||
      m.type === 'textContainer' ||
      m.type === 'M365' ||
      m.type === 'pdf' ||
      m.type === 'html'
    ) {
      const _to =
        formatCLink(m.type, m.value, m.module, m.spnId, m.iframe, m.link) ||
        m.link;
      return convertModtoNavProps(m, _to);
    }
    const moduleInDefault = defaultRoutesToShow.find(
      (r) => getIconId(r.icon) === getIconId(m.icon),
    );

    // debugger;

    return convertDefaultToNavProps({
      ...moduleInDefault,
      displayName: m.module,
      label: m.module,
      ...m,
    });
  });
};

export const getIsItemActive = (location) => (m) => {
  const label = m.to;

  if (label === '/projects') {
    return Object.assign(m, {
      isActive: location.pathname === '/projects/list',
    });
  }

  let isActive = false;
  if (
    [
      'powerBI',
      'link',
      'imageLink',
      'pdfLink',
      'htmlLink',
      'widgetLink',
      'textContainer',
      'multiSectionLink',
    ].some((i) => location.pathname?.includes(i))
  ) {
    isActive = location.pathname + location.search === decodeURIComponent(m.to);
  } else {
    isActive =
      location.pathname.toLowerCase().includes(label.toLowerCase()) ||
      label.toLowerCase().includes(location.pathname.toLowerCase());
  }

  return Object.assign(m, { isActive });
};

export const formatLink = (link) => {
  const _link =
    link.trim().indexOf('http://') === 0 ||
    link.trim().indexOf('https://') === 0
      ? link
      : `https://${link}`;
  return encodeURIComponent(_link);
};

export const formatCLink = (
  type,
  moduleValue,
  moduleName,
  spnId,
  iframe,
  link,
) => {
  const projectId = getSessionStorage('currentId');
  if (!moduleValue || !projectId || projectId === 'null') {
    return;
  }
  if (type === 'widget') {
    return `projects/widgetLink?projectId=${projectId}&moduleValue=${moduleValue}&link=${link}`;
  }
  if (type === 'multiSection') {
    return `projects/multiSectionLink?projectId=${projectId}&moduleValue=${moduleValue}`;
  }
  //add process of none-iframe type above
  if (!iframe) {
    return;
  }
  if (type === 'powerbiModule') {
    return `powerBI?moduleValue=${moduleValue}&projectId=${projectId}`;
  }
  if (type === 'imageModule') {
    return `projects/imageLink?moduleValue=${moduleValue}&projectId=${projectId}`;
  }
  if (type === 'regular') {
    return `link?projectId=${projectId}&moduleValue=${moduleValue}`;
  }
  if (type === 'M365') {
    return `link?projectId=${projectId}&moduleValue=${moduleValue}&M365=true`;
  }
  if (type === 'textContainer') {
    return `textContainer?projectId=${projectId}&moduleValue=${moduleValue}`;
  }
  if (type === 'pdf') {
    return `projects/pdfLink?moduleValue=${moduleValue}&projectId=${projectId}`;
  }
  if (type === 'html') {
    return `projects/htmlLink?moduleValue=${moduleValue}&projectId=${projectId}`;
  }
  return undefined;
};
